var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72643 4.79881V12.8058C6.48767 12.7246 6.22184 12.6753 5.93878 12.6753C4.92467 12.6753 4.1001 13.2636 4.1001 13.9873C4.1001 14.7134 4.92221 15.2992 5.93878 15.2992C6.95288 15.2992 7.77746 14.7109 7.77746 13.9873C7.77746 13.8987 7.76515 13.8101 7.74054 13.7239H7.77746V7.12485L13.0277 5.62585V11.233C12.7889 11.1517 12.5231 11.1025 12.24 11.1025C11.2259 11.1025 10.4013 11.6908 10.4013 12.4144C10.4013 13.1406 11.2234 13.7264 12.24 13.7264C13.2541 13.7264 14.0787 13.1381 14.0787 12.4144C14.0787 12.3307 14.0664 12.2495 14.0442 12.1683L14.0787 12.1511V2.69922L6.72643 4.79881Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.d12def5cc34624e15e28985c4e4fbb1e.svg";
export { ForwardRef as ReactComponent };